export default {
	"indexTitle": {
		"title1": "Register",
		"title2": "Login",
		"title3": "Download Mobile App",
		"title4": "Deposit",
		"title5": "Withdraw",
		"title6": "Sports",
		"title7": "Live Casino",
		"title8": "Slot Machines",
		"title9": "Poker",
		"title10": "Fishing",
		"title11": "Animal Races",
		"title12": "E-sports",
		"title13": "Lottery",
		"title14": "Promotions",
		"title15": "Download Mobile App",

		"title16": "Visit History",
		"title17": "Start Game",
		"title18": "Latest News",
		"title19": "Please note, when using Alipay, Octopus, tap&go, BOC, etc. for bank deposits, you must select FPS and verify the payee's full English name!",
		"title20": "All Promotions",
		"title21": "Apply for This Promotion",
		"title22": "I Want to Play",
		"title23": "Balance",
		"title24": "My Account",
		"title25": "VIP",
		"title26": "Deposit",
		"title27": "Withdraw",
		"title28": "Invite Friends",
		"title29": "Task Log",
		"title30": "Promotions Center",
		"title31": "Game Records",
		"title32": "Financial Records",
		"title33": "Announcements Center",
		"title34": "Affiliate Program",
		"title35": "Direct Members",
		"title36": "My Commission",
		"title37": "Rules Explanation",
		"title38": "Team Members",
		"title39": "New Team Members Today",
		"title40": "Direct Members Count",
		"title41": "New Direct Members Today",
		"title42": "Today's Team Turnover",
		"title43": "Today's Direct Turnover",
		"title44": "Affiliate Earnings",
		"title45": "Bonus",
		"title46": "Subordinate Members Count",
		"title47": "Estimated High Bonus Potential",
		"title48": "Personal Information",
		"title49": "Referral Code",
		"title50": "Invitation Link",
		"title51": "Invitation QR Code",
		"title52": "Promotion Tools",
		"title53": "Download",
		"title54": "My Account",
		"title55": "New Password",
		"title56": "Change Withdrawal Password",
		"title57": "Old Password",
		"title58": "Required",
		"title59": "Please enter your login password",
		"title60": "Confirm New Password",
		"title61": "Cancel",
		"title62": "Update",
		"title63": "Please Enter Old Password",
		"title64": "Please Enter New Password",
		"title65": "Passwords Do Not Match",
		"title66": "Update Failed",
		"title67": "Login Password",
		"title68": "New Withdrawal Password",
		"title69": "6~10 characters in English and numbers combination (special characters allowed)",
		"title70": "Confirm Withdrawal Password",
		"title71": "Please Enter Login Password",
		"title72": "Please Enter New Withdrawal Password",
		"title73": "Deposit Options",
		"title74": "Promotions",
		"title75": "No Data Available",
		"title76": "FPS",
		"title77": "Convenience Store Top-up",
		"title78": "No Deposit Limit",
		"title79": "Service Fee",
		"title80": "No Service Fee",
		"title81": "Please Enter Deposit Amount",
		"title82": "Please Enter Payer Name",
		"title83": "Deposit Bonus",
		"title84": "Please Select",
		"title85": "Get Payment Information",
		"title86": "Payment Instructions",
		"title87": "1. Please select the payment channel, enter the amount, and click submit.",
		"title88": "2. After redirecting to the third-party payment page, follow the instructions to complete the deposit within the time limit.",
		"title89": "3. After the payment is completed, wait for the page to show a successful payment message before closing it to avoid missing the transaction.",
		"title90": "4. After the third-party platform confirms, the system will automatically credit your account.",
		"title91": "5. Payment not credited? Unable to pay? Please contact [Online Customer Service] for assistance.",
		"title92": "Deposit Amount",
		"title93": "Please note the following recipient information and make the transfer",
		"title94": "Recipient Account Number",
		"title95": "Recipient Account Name",
		"title96": "Recipient QR Code",
		"title97": "Deposit Address",
		"title98": "Return to Re-enter",
		"title99": "Confirm Deposit",
		"title100": "Copy Successful!",
		"title101": "Start",
		"title102": "End",
		"title103": "You can check data up to 31 days prior to today",
		"title104": "Search",
		"title105": "Total Deposits",
		"title106": "Total Withdrawals",
		"title107": "Total Promotions",
		"title108": "Rebate Records",
		"title109": "Manual Adjustment Records",
		"title110": "Referral Records",
		"title111": "Task Reward Records",
		"title112": "*There may be delays when accessing data. If no game records are found, please try again later. Overview data is aggregated based on GMT+8 time and only shows data for the last 10 days",
		"title113": "Product Type",
		"title114": "Game",
		"title115": "Date",
		"title116": "Total Bets",
		"title117": "Total Valid Bets",
		"title118": "Total Win/Loss",
		"title119": "Settled",
		"title120": "Bet Amount",
		"title121": "Transaction ID",
		"title122": "No Records Found",
		"title123": "Personal Information",
		"title124": "Bank Card Information",
		"title125": "All Wallets",
		"title126": "Change Login/Withdrawal Password",
		"title127": "Referral Code",
		"title128": "Player Account",
		"title129": "Real Name",
		"title130": "Phone Number",
		"title131": "Registration Time",
		"title132": "Total Amount",
		"title133": "Add New Bank Card",
		"title134": "Bank Card Number",
		"title135": "Account Holder Name",
		"title136": "Must Match Your Bank Account Name, Otherwise Withdrawals Cannot Be Processed",
		"title137": "Recipient Bank",
		"title138": "Bank Account Number",
		"title139": "Please Enter Your Bank Account Number",
		"title140": "Bank Branch",
		"title141": "Please Enter Your Bank Branch",
		"title142": "Confirm",
		"title143": "Please Enter Account Holder Name",
		"title144": "Please Enter Recipient Bank",
		"title145": "Please Enter Bank Account Number",
		"title146": "Please Enter Bank Branch",
		"title147": "Countdown Time",
		"title148": "Daily Deposit",
		"title149": "Above HKD",
		"title150": "Activity Points",
		"title151": "Points",
		"title152": "Cumulative Logins",
		"title153": "Days",
		"title154": "Completed",
		"title155": "Available to Claim",
		"title156": "Task in Preparation",
		"title157": "Platform Announcement",
		"title158": "Total",
		"title159": "Application Time",
		"title160": "Review Time",
		"title161": "Pending Confirmation",
		"title162": "Success",
		"title163": "Failure",
		"title164": "Actual Amount",
		"title165": "Remarks",
		"title166": "Order Number",
		"title167": "More Content",
		"title168": "VIP Level",
		"title169": "Current Level",
		"title170": "VIP Benefits Explanation",
		"title171": "Promotion",
		"title172": "Conditions",
		"title173": "Passed",
		"title174": "Current Points",
		"title175": "Congratulations Achieved",
		"title176": "Exclusive Privileges",
		"title177": "Insufficient Level",
		"title178": "Birthday Bonus",
		"title179": "Claim",
		"title180": "Points History",
		"title181": "Level Up/Down",
		"title182": "Claim Records",
		"title183": "Withdrawal Amount",
		"title184": "Total Audit Deduction",
		"title185": "Withdrawal Password",
		"title186": "Actual Withdrawal",
		"title187": "Withdrawal Amount Should Be Between 1.00 and 10.00",
		"title188": "Please Bind Bank Card First",
		"title189": "Please Enter Withdrawal Amount",
		"title190": "Please Enter Withdrawal Password",
		"title191": "Player Login",
		"title192": "Account",
		"title193": "Password",
		"title194": "Not Registered Yet? Click Here",
		"title195": "Forgot Account",
		"title196": "Forgot Password",
		"title197": "Please Enter Player Account",
		"title198": "Please Enter Player Password",
		"title199": "Player account must have 6-12 characters",
		"title200": "China (China)",
		"title201": "Hong Kong (Hong Kong)",
		"title202": "Re-enter",
		"title203": "Register Now",
		"title204": "Please Enter Account",
		"title205": "Please Enter Password",
		"title206": "Please Enter Phone Number",
		"title207": "Daily Tasks",
		"title208": "Roulette",
		"title209": "Referral Progress",
		"title210": "Contact Us",
		"title211": "About Us",
		"title212": "Logout",
		"title213": "Free Registration",
		"title214": "Sports Events",
		"title215": "Live Entertainment",
		"title216": "Electronic Games",
		"title217": "Card Games",
		"title218": "Fishing Games",
		"title219": "Animal Racing",
		"title220": "E-sports",
		"title221": "Android Scan",
		"title222": "iOS Scan",
		"title223": "Play Now",
		"title224": "Event Period:",


		"title225": "Withdrawal Password",
		"title226": "Payment Channel",
		"title227": "All",
		"title228": "Player Deposit",
		"title229": "Deposit History",
		"title230": "Help Center",
		"title231": "Deposit Help",
		"title232": "Hello,",
		"title233": "Card Management",
		"title234": "Daily Missions",
		"title235": "Cumulative Tasks",
		"title236": "Period Mission",
		"title237": "Check-in Task",
		"title238": "Not Activated",
		"title239": "Change Withdrawal Password",
		"title240": "Player Account",
		"title241": "Roulette wheel points",
		"title242": "Real Name",
		"title243": "mobile number",
		"title244": "Date of Birth",
		"title245": "Registration time",
		"title246": "Last login password",
		"title247": "VIP Record",
		"title248": "Withdrawal History",
		"title249": "Withdrawable amount",
		"title250": "Preferential Audit",
		"title251": "Deductions",
		"title252": "Administrative Costs",
		"title253": "Commission",
		"title254": "Discount",
		"title255": "Normalcy Audit",
		"title256": "Clause",
		"title257": "Heaven",
		"title258": "Amount",
		"title259": "Get Amount:",
		"title260": "Size:",
		"title261": "Sign-in",
		"title262": "Checked in",
		"title263": "Total Check-in Days:",
		"title264": "Total Sign-in Revenue:",
		"title265": "Deposit amount of the day:",
		"title266": "Valid bets of the day:",
		"title267": "Required Deposit Amount:",
		"title268": "Required number of valid yards:",
		"title269": "Number of turns:",
		"title270": "times",
		"title271": "Completed the mission today",
		"title272": "Not up to standard",
		"title273": "Home",
		"title274": "Offer",
		"title275": "Make money",
		"title276": "Account",
		"title277": "Number of days of no-show",

		"title278": "Check-in Conditions",
		"title279": "Achieved!",
		"title280": "Identity Verification Gold Required",
		"title281": "to participate in this event",
		"title282": "Sign in and get a bonus",
		"title283": "Total number of active days",
		"title284": "Total Prize",
		"title285": "Select Currency",
		"title286": "Please enter your English name",
		"title287": "Account number at least 6",
		"title288": "Bank Account",
		"title289": "Minimum:",
		"title290": "Maximum:",
		"title291": "Top-up amount",
		"title292": "Lowest Deposit Amount",
		"title293": "Highest Deposit amount",
		"title294": "The login status is invalid, please log in again",
		"title295": "Card Name",
		"title296": "Bank",
		"title297": "Card Account Number",
		"title298": "Please enter a 6-digit withdrawal password",
		"title299": "This action will transfer all balances back to the main wallet, do you want to continue?",
		"title300": "Cancel",
		"title301": "Continue",
		"title302": "Withdrawal password is 6 digits",
		"title303": "Funds Recovery",
		"title304": "Customer Service",
		"title305": "Yard Balance",
		"title306": "Real-time Rebate",
		"title307": "Claim",
		"title308": "Minimum deposit amount",

		"title309": "Download for iPhone",
		"title310": "Support Apple",
		"title311": "Above",
		"title312": "Download Android",
		"title313": "Android supported",
		"title314": "WeChat players, please use mobile browser",
		"title315": "Click to copy URL",

		"title316": "Event Prize",
		"title317": "My Prize",
		"title318": "Turntable",
		"title319": "Bonus Bonus:",
		"title320": "The number of valid bets required by a live person:",
		"title321": "The number of valid bets required for fishing:",
		"title322": "The number of electronically qualifying bets is required:",
		"title323": "The number of valid bets on the ticket is required:",
		"title324": "The number of valid bets on sports is required:",
		"title325": "The number of valid bets is required:",
		"title326": "Require the number of other valid bets:",
		"title327": "Baccarat",

		"title328": "Real-time rebate",
		"title329": "Click to claim",
		"title330": "Yuan",
		"title331": "Live Rebate Amount:",
		"title332": "Sports Rebate:",
		"title333": "Electronic Rebate Amount:",
		"title334": "Chess Rebate Amount:",
		"title335": "Claim Instructions",
		"title336": "The claim time is 16:00:00-23:59:59, if not claimed within this time period, it will be cleared",
		"title337": "Only provide 14 days of transaction information inquiry",
		"title338": "Fishing Rebate Amount:",
		"title339": "Esports Rebate:",
		"title340": "Animal Rebate Amount:",
		"title341": "Main wallet",
		"title342": "Game Wallet",
		"title343": "Route selection",
		"title344": "Customer Service (Line 1)",
		"title345": "Customer Service (Line 2)",
		"title346": "Valid Bets",
		"title347": "Not participating in activities",
		"title348":"Sign in activity",
		"title349":"Roulette Lottery",
		"title350":"Red envelope activity",
		"title351":"Menu",
		"title352":"Back",
		"title353":"Language",
		"title354":"Fiat Currency",
		"title355":"Cryptocurrency",
		"title356":"Deposit Currency",
		"title357":"Deposit Type",
		"title358":"Bank Transfer",
		"title359":"FPS",
		"title360":"Hot",
		"title361":"Select Promotion",
		"title362":"No Promotion",
		"title363":"Select Network",
		"title364":"Members making their first deposit can claim the first deposit bonus in the bonus section.",
		"title365":"Deposit Address",
		"title366":"Copy Address",
		"title367":"Auto Crediting, Exchange Rate",
		"title368":"Receiving Institution",
		"title369":"Order Number",
		"title370":"Contact Information",
		"title371":"Phone Verification",
		"title372":"Verified",
		"title373":"Verify",
		"title374":"Change Login Password",
		"title375":"Change your password regularly to maintain its uniqueness and security.",
		"title376":"Change Payment Password",
		"title377":"Please enter your original password",
		"title378":"6-digit combination (no other characters allowed)",
		"title379":"Phone Verification",
		"title380":"Show All",
		"title381":"Collapse",
		"title382":"General Bonus",
		"title383":"Roulette Points",
		"title384":"Total Bonus Received",
		"title385":"Detailed Information",
		"title386":"Available Now",
		"title387":"Claim Reward",
		"title388":"Red Packet Bonus",
		"title389":"Up To",
		"title390":"Check-in Bonus",
		"title391":"Daily Live Casino Bonus",
		"title392":"Daily Sports Bonus",
		"title393":"Daily Slots Bonus",
		"title394":"Daily Chess & Cards Bonus",
		"title395":"Daily Fishing Game Bonus",
		"title396":"Daily Esports Bonus",
		"title397":"Daily Other Games Bonus",
		"title398":"Daily Roulette Points",
		"title399":"Deposit Today",
		"title400":"Turnover Today",
		"title401":"Random Red Packet",
		"title402":"Promotion Rules & Terms",
		"title403":"Red Packet Application: Deposit ",
		"title404":"Turnover",
		"title405":"You may claim it on the event page today.",
		"title406":"Bonus from this promotion is withdrawable at 1x turnover only.",
		"title407":"Each player may apply once per day; maximum random red packet amount",
		"title408":"Each player may register only one account. Multiple accounts for events are considered arbitrage and will be blocked.",
		"title409":"WG CLUB reserves the right to modify or terminate this event and holds final interpretation rights.",
		"title410":"This platform specially introduces a daily check-in bonus system. As long as you meet the required conditions, you can qualify for check-in. Accumulating check-ins brings more surprises, and the check-in count resets at 00:00 every Monday!",
		"title411":"Participate and meet the requirements to get extra roulette points every day for endless gaming fun!",
		"title412":"Participate and meet the requirements to get extra real cash rewards every day for endless gaming fun!",
		"title413":"Participate and meet the requirements to get extra sports bonuses every day for endless gaming fun!",
		"title414":"Participate and meet the requirements to get extra electronic game bonuses every day for endless gaming fun!",
		"title415":"Participate and meet the requirements to get extra board & card game bonuses every day for endless gaming fun!",
		"title416":"Participate and meet the requirements to get extra fishing game bonuses every day for endless gaming fun!",
		"title417":"Participate and meet the requirements to get extra esports bonuses every day for endless gaming fun!",
		"title418":"Consecutive Check-ins",
		"title419":"Casino",
		"title420":"Cinema",
		"title421":"Play Now",
		"title422":"Today",
		"title423":"Yesterday",
		"title424":"Last 7 Days",
		"title425":"Last 30 Days",
		"title426":"Show 100 items per page, Total Count:",
		"title427":"Type",
		"title428":"Time",
		"title429":"Unsettled",
		"title430":"Cancelled",
		"title431":"Selected",
		"title432":"State",
		"title433":"Already have an account",
		"title434":"Discounts related",
		"title435":"Remember the username and password",
		"title436":"Total amount of discounts claimed in the last 30 days",
		"title437": "Agent Commission",
		"title438": "Referral Code",
		"title439": "Commission Bonus",
		"title440": "Redemption Record",
		"title441": "Valid Bets of Friends Yesterday",
		"title442": "Withdrawable Commission",
		"title443": "What are the deposit and withdrawal requirements?",
		"title444": "The minimum deposit amount is 100 HKD, and the minimum withdrawal amount is 100 HKD. For agents withdrawing via USDT, the amount must reach over 10,000 HKD; please contact customer service to bind USDT for withdrawal. Commission requires 1 time valid betting turnover before withdrawal.",
		"title445": "How is the referral bonus calculated?",
		"title446": "Referral bonus calculation rule: Invite subordinates to register and place bets, you can get a 0.3% rebate from subordinate members' betting amount. Calculation example: If a subordinate member bets 5,000,000 HKD, the commission you can receive is 5,000,000 * 0.3% = 15,000 HKD commission.",
		"title447": "How often are dividend bonuses settled?",
		"title448": "Agent commission is settled in real-time. You will receive commission immediately when your subordinate members place bets.",
		"title449":"Daily Animal Esports Prize Money",
		"title450":"Participate and meet the requirements to get extra Animal Esports bonuses every day for endless gaming fun!",
		"title451": "Promote to",
		"title452": "Rules",
		"title453": "Level",
		"title454": "Promotion Bonus",
		"title455": "Weekly Bonus",
		"title456": "Monthly Bonus",
		"title457": "Transfer Bonus",
		"title458": "VIP Level System",
		"title459": "Maintenance XP",
		"title460": "Upgrade XP",
		"title461": "Promotion Criteria",
		"title462": "When a member meets the required valid wagering amount for the corresponding level, the system will automatically judge and promote them to the corresponding VIP level. (The required valid wagering amount for each VIP level promotion will be recalculated).",
		"title463": "Maintenance Requirements",
		"title464": "After a member reaches a certain VIP level, they need to complete the maintenance wagering requirement within 60 days (half of the required wagering amount for promotion to the current level equals the maintenance wagering requirement). If a promotion is completed during this period, the maintenance requirement will be recalculated according to the current level.",
		"title465": "Demotion Criteria",
		"title466": "If a member fails to complete the corresponding maintenance requirements within 60 days, the system will automatically demote them by one level (the required valid wagering amount for each VIP level will be recalculated upon demotion), and the corresponding benefits will be adjusted to the demoted level.",
		"title467": "Promotion Bonus",
		"title468": "After a member is promoted to a higher level, they can claim the promotion bonus on the VIP page. The promotion bonus for each level can only be received once. The promotion bonus requires 1x wagering to be withdrawn.",
		"title469": "VIP Weekly Bonus",
		"title470": "VIP bonuses can be claimed once a week. The bonus amount corresponds to the current level and can be claimed accordingly. It updates every Monday at 00:00. If overdue, the bonus for the previous week cannot be claimed. The bonus requires 1x valid wagering to be withdrawn, and participation is limited to once a week.",
		"title471": "VIP Monthly Bonus",
		"title472": "VIP bonuses can be claimed once a month. The bonus amount corresponds to the current level and can be claimed accordingly. It updates on the 1st of each month at 00:00. If overdue, the bonus for the previous month cannot be claimed. The bonus requires 1x valid wagering to be withdrawn, and participation is limited to once a month.",
		"title473": "VIP Club",
		"title474": "Copy",
		"title475": "Invitation to Friends",
		"title476": "Performance Inquiry",
		"title477": "Reward has been claimed",
		"title478": "This Week's Received",
		"title479": "Picked up this month",
		"title480": "Daily Claimed",
		"title481": "Account (6-12 English letters and numbers)",
		"title482": "Password (6~16 characters)",
		"title520": "Event Details",
		"title521": "Claim",
		"title522": "Daily check-in bonus: complete the required conditions to receive your check-in bonus.",
		"title523": "Check-in streak resets every Monday at 00:00.",
		"title524": "How to get roulette spins?",
		"title525": "1. Roulette spins are automatically distributed based on daily deposits.",
		"title526": "2. For roulette point details, please visit the Promotions Center.",
		"title527": "⚠️ Note:",
		"title528": "1. Roulette points must be used on the same day.",
		"title529": "2. Unused roulette points are not carried over and reset daily at 00:00.",
		"title530": "3. Roulette winnings require 1x valid wagering before withdrawal.",
		"title531": "Bonus Pool",
		"title532": "Yu'e Bao",
		"title533": "Claim bonuses anytime",
		"title534": "Earn on idle balance",
		"title535": "Total Amount (HK$)",
		"title536": "Annual Rate",
		"title537": "Transfer In",
		"title538": "Claim",
		"title539": "Transfer Out",
		"title540": "Current Earnings",
		"title541": "Total Bonus",
		"title542": "Cumulative Earnings",
		"title543": "Details",
		"title544": "Yu'e Bao Rules",
		"title545": "Earnings",
		"title546": "Claims",
		"title547": "Transfers Out",
		"title548": "Transfers In",
		"title549": "Earnings",
		"title550": "No records yet",
		"title551": "Main wallet balance",
		"title552": "Yu'e Bao balance",
		"title553": "Enter amount",
		"title554": "Confirm",
		"title555": "Interest Rules\n• Main account funds must meet withdrawal turnover requirements before transferring to Yu'e Bao.\n• Interest is calculated at the annual rate, with each hour as one settlement cycle:\nYu'e Bao balance × annual rate ÷ 365 ÷ 24 = hourly earnings.\n• Earnings start 2 hours after deposit; transfer-out bonus rewards are not affected.\n• Each deposit earns interest for up to 12 hours; after 12 hours, you must deposit again to continue earning.\n• Example at 365% annual rate: 100,000 HKD in Yu'e Bao earns about 500 HKD in 12 hours.\n\nTransfer Out Rules\nBonus rate:\n• Each transfer from Yu'e Bao to the main account earns a 1% bonus, up to 2 times per day, max 388 HKD per 1% bonus.\nTransfer requirements:\n• After transfer to the main account, you must complete 1x turnover on (transfer amount + bonus) before withdrawal.",
		"title556": "Operation failed. Please try again later.",
		"title557": "Main Wallet (HK$)",
		"title558": "Yu'e Bao Wallet (HK$)",
		"title559": "Transfer In Amount",
		"title560": "Withdrawal Password",
		"title561": "Main account funds must meet turnover and withdrawal requirements before transfer to Yu'e Bao.",
		"title562": "Transfer Out",
		"title563": "Total Balance",
		"title564": "Unclaimed Earnings",
		"title565": "Transfer Out Amount",
		"title566": "Bonus Amount",
		"title567": "Bonus Rules:",
		"title568": "1. Transfer out bonus {rate}%, 2 times/day",
		"title569": "2. After transfer, principal + bonus requires 1x turnover",
		"title572": "Total Received",
		"title573": "Transfer Out Bonus",
		"title574": "Bonus Pool",
		"title575": "Claimable",
		"title576": "In Progress",
		"title577": "Claimed",
		"title578": "Expired",
		"title579": "Points Center",
		"title580": "Priority Wagering",
		"title581": "Refresh",
		"title582": "Bonus",
		"title583": "First deposit up to 150% - Claim by wagering",
		"title584": "Required Turnover",
		"title585": "Wagering Start",
		"title586": "Wagering Deadline",
		"title587": "Valid Games",
		"title588": "Completed",
		"title589": "Current Turnover",
		"title590": "Remaining",
		"title591": "Tiered Rewards",
		"title592": "Total Bonus",
		"title593": "Claimed",
		"title594": "Tier ",
		"title594b": "",
		"title595": "Progress ≥",
		"title596": "Eligible — claim this tier now",
		"title597": "Claim Reward",
		"title598": "Progress requirement not met",
		"title599": "Not Eligible",
		"title600": "No promotions in progress",
		"title601": "Live (20%), Sports (100%), Cards (100%), Slots (100%), Esports (100%), Fishing (100%)",
		"title602": "No claimable bonuses",
		"title603": "No claimed records",
		"title604": "No expired records",
		"title605": "Points center coming soon",
		"title606": "Set priority wagering",
		"title607": "Cumulative Claimed Amount",
		"title608": "No more",
		"title609": "VIP Bonus",
		"title610": "Manual Promotion",
		"title611": "Reward",
		"title612": "Hot Games",
		"title613": "Mini",
		"title614": "Search games...",
		"title615": "No games found",
		"title616": "No hot games",
		"title617": "No mini games",
		"title618": "No live games",
		"title619": "No games",
		"title620": "Back to providers",
		"title621": "Winners",
		"title622": "Loading",
		"title623": "User",
		"title624": "Mul",
		"title625": "Win",
		"title626": "Change Language",
		"title627": "NEW",
		"title628": "HOT",
		"title629": "Special promotions for you",
		"title630": "View Details",
		"title631": "No promotions",
		"title632": "Welcome back",
		"title633": "Login to start playing",
		"title634": "Don't have an account?",
		"title635": "Create an account",
		"title636": "Sign up to start playing",
		"title637": "Account Info",
		"title638": "Next",
		"title639": "Bank Info",
		"title640": "Select bank",
		"title641": "Already have an account?",
		"title642": "Rank",
		"title643": "Enter full name",
		"title644": "Confirm Password",
		"title645": "Login failed",
		"title646": "Register failed",
		"title647": "Failed to send code",
		"title648": "Password must be at least 6 characters",
		"title649": "Please enter your name",
		"title650": "Bet",
		"title651": "Bank account / PromptPay ID",
		"title652": "Play History",
		"title653": "No play history",
		"title654": "Contact channels",
		"title655": "24h service",
		"title656": "Fast response",
		"title657": "Secure chat",
		"title658": "Choose a contact method",
		"title659": "Chat now",
		"title660": "No contact channels",
		"title661": "LINE",
		"title662": "Your level",
		"title663": "Total deposit",
		"title664": "Highest level reached",
		"title665": "All levels",
		"title666": "Current",
		"title667": "Channel",
		"title668": "Amount",
		"title669": "Pay",
		"title670": "Balance",
		"title671": "Your account",
		"title672": "Select payment method",
		"title673": "Selected channel",
		"title674": "Select amount",
		"title675": "Or enter amount",
		"title676": "Enter amount",
		"title677": "Minimum deposit",
		"title678": "THB",
		"title679": "Bank transfer + upload slip",
		"title680": "Online payment",
		"title681": "Receiving account",
		"title682": "Bank",
		"title683": "Wallet",
		"title684": "Wallet withdrawal not available",
		"title685": "Min withdrawal ",
		"title686": "Max withdrawal",
		"title687": "Withdraw",
		"title688": "Minimum withdrawal: ",
		"title689": "USDT address",
		"title690": "Enter USDT address",
		"title691": "Bind USDT",
		"title692": "Bound",
		"title693": "Please bind a USDT address first",
		"title694": "Network",
		"title695": "Refund your game balance.",
		"title696": "Loss Refund",
		"title697": "Yesterday's total loss",
		"title698": "Loss rebate rate",
		"title699": "Claimable amount",
		"title700": "Loading...",
		"title701": "Claiming...",
		"title702": "Claimed today",
		"title703": "No loss rebate available",
		"title704": "Claim",
		"title705": "Claimed successfully",
		"title706": "Refund your betting losses from yesterday.",
		"title707": "Request a refund for yesterday's losses.",
		"title708": "No eligible losses (you did not lose money yesterday).",
		"title709": "How to apply for loss compensation.",
		"title710": "Play games and accumulate betting points.",
		"title711": "Loss = Total bets - Total wins - Previous day's rebate.",
		"title712": "If you have a loss, you can get a refund every day.",
		"title713": "The cashback rate depends on your level.",
		"title714": "Loss refund history",
		"title715": "No loss compensation records yet.",
		"title716": "Refund yesterday's betting amount.",
		"title717": "Apply to refund yesterday's betting amount.",
		"title718": "No minimum bet required for cashback.",
		"title719": "How to get cashback",
		"title720": "Play games and accumulate betting points.",
		"title721": "Cashback is calculated from the previous day's bets.",
		"title722": "Come back every day to claim your cash rebate!",
		"title723": "The cashback rate depends on your level.",
		"title724": "Cashback receipt history",
		"title725": "Cashback",
		"title726": "No cashback records yet.",
		"title727": "Lucky Wheel",
		"title728": "Your tickets",
		"title729": "Available today",
		"title730": "Wheel",
		"title731": "Records",
		"title732": "Spin the wheel",
		"title733": " ticket",
		"title734": "Not enough tickets.",
		"title735": "Each spin costs 1 ticket",
		"title736": "All prizes",
		"title737": "Prize",
		"title738": "Check-in",
		"title739": "Total check-ins",
		"title740": "Points earned",
		"title741": "pts",
		"title742": "Meet the conditions to claim your check-in bonus.",
		"title743": "Check in now",
		"title744": "Checked in",
		"title745": "Today",
		"title746": "Check-in rules",
		"title747": "You must meet today’s deposit and valid betting requirements for the current day tier before claiming the check-in bonus.",
		"title748": "If you miss a day, the streak restarts from day 1. Longer streaks unlock bigger rewards.",
		"title749": "Collect points in the shop and redeem rewards.",
		"title750": "After meeting the requirements, check in to claim <em>{n}</em> bonus.",
		"title751": "/",
		"title752": "",
		"title753": "Su,Mo,Tu,We,Th,Fr,Sa",
		"title570": "Please enter 6-digit withdrawal password",
		"title571": "No balance available to transfer out",
		"title483": "Please enter your real English name",
		"title484": "Please enter your phone number",
		"title485": "Withdrawal Password (6-digit number)",
		"title486": "Please enter the old withdrawal password",
		"title487": "Verification Code",
		"title487Err": "Please enter verification code",
		"title488": "Get Code",
		"title489": "Account Login",
		"title490": "Phone Login",
		"title491": "Forgot Password",
		"title492": "Set New Password",
		"title493": "Confirm",
		"title494": "Commission BonusCommission reward has been claimed.",
		"title495": "Delete",
		"title496": "Delete Bank Card",
		"title497": "Cancel",
		"title498": "Confirm Delete",
	},

};